import React, { useRef } from "react";
import { ProgressStepForm, FormStep } from "./ProgressStepForm";
import { getFormInput } from "./utils";
import Column from "@amzn/meridian/column";
import { addFeatureValidationSchema, createPropertyConfig } from "./definitions";
import { useSheets } from "../../features/sheets/hooks";
import { Space } from "../space/Space";

export const AddFeatureForm = ({ initialValues, onSubmitHandler }) => {
    const addSpaceFormRef = useRef(null);

    const { addFeature } = createPropertyConfig;
    const { setOpenSheets } = useSheets();

    return (
        <Column width={"100%"} spacing={"none"}>
            <Column width={"fill"}>
                <ProgressStepForm
                    onSubmit={values => {
                        onSubmitHandler(values);
                        setOpenSheets(false);
                    }}
                    formName={"createProperty"}
                    initialValues={initialValues}
                    formRef={addSpaceFormRef}
                >
                    <FormStep
                        onSubmit={() => console.log("Feature submitted")}
                        validationSchema={addFeatureValidationSchema}
                    >
                        {getFormInput({ addFeature })}
                    </FormStep>
                </ProgressStepForm>
            </Column>
            <Space size={"m"} />
        </Column>
    );
};
